const CREDENTIAL_TYPES = [
  {
    name: "IMAP",
    label: "IMAP",
    type: "IMAP",
    fields: [
      {
        name: "user",
        label: "User",
        type: "text",
        placeholder: "demo@megafintech-hk.com",
      },
      {
        name: "password",
        label: "Password",
        type: "password",
      },
      {
        name: "host",
        label: "Host",
        type: "text",
        placeholder: "imap.gmail.com",
      },
      {
        name: "port",
        label: "Port",
        type: "number",
        placeholder: "993",
      },
      {
        name: "tls",
        label: "TLS",
        type: "checkbox",
        defaultValue: true,
      },
    ],
  },
  //OpenRouter
  {
    name: "OpenRouter",
    label: "OpenRouter",
    type: "OpenRouter",
    fields: [
      {
        name: "apiKey",
        label: "API Key",
        type: "text",
      },
      {
        name: "model",
        label: "Model",
        type: "select",
        options: [
          {
            label: "deepseek/deepseek-chat-v3-0324",
            value: "deepseek/deepseek-chat-v3-0324",
          },
        ],
        placeholder: "deepseek/deepseek-chat-v3-0324",
      },
      {
        name: "temperature",
        label: "Temperature",
        type: "number",
        placeholder: "0.3",
        defaultValue: 0.3,
        precision: 1,
      },
      {
        name: "baseUrl",
        label: "Base URL",
        type: "text",
        placeholder: "https://openrouter.ai/api/v1/chat/completions",
        defaultValue: "https://openrouter.ai/api/v1/chat/completions",
      },
      {
        name: "referer",
        label: "Referer",
        type: "text",
        placeholder: "http://localhost",
        defaultValue: "http://localhost",
      },
      {
        name: "xtitle",
        label: "X-Title",
        type: "text",
        placeholder: "Chat",
        defaultValue: "Chat",
      },
    ],
  },
];

export default CREDENTIAL_TYPES;
